import { ILoginInfo } from "@/components/LoginForm";
import {
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/react";
import { FormikTouched } from "formik";
import { ChangeEvent } from "react";

export type LoginInputProps = {
  name: string;
  touched: FormikTouched<ILoginInfo>;
  id: "username" | "password";
  rightIcon?: JSX.Element;
  isPassword?: boolean;
  onIconClick?: () => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  formatFn?: (value: string) => string;
} & InputProps;

export default function LoginInput({
  name,
  setFieldValue,
  formatFn,
  touched,
  id,
  rightIcon,
  onIconClick,
  isPassword = false,
  ...props
}: LoginInputProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;
    if (formatFn) {
      inputValue = formatFn(inputValue);
    }
    setFieldValue(name, inputValue);
  };

  return (
    <InputGroup>
      <Input
        type="text"
        border="1px solid #D9D9D9"
        bgColor="white"
        w="100%"
        borderRadius="4px"
        color="black"
        fontFamily="Lexend Deca"
        fontSize="14px"
        fontWeight="400"
        onChange={handleChange}
        value={props.value}
        {...props}
      />
      {isPassword && (
        <InputRightElement onClick={onIconClick} cursor="pointer">
          {rightIcon}
        </InputRightElement>
      )}
    </InputGroup>
  );
}
